import React, { useEffect, useState } from 'react'
import { TreeStandards } from 'components/tree/standardUtilities'
import { Box, TextField } from '@mui/material'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import { StandardStateSelect } from 'components/standards/StandardStateSelect'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { workingTreeAtom } from '../findAndReplace/atoms'
import { ReplaceStandardsTable } from './ReplaceStandardsTable'
import { getNormalizedReplacementMap } from './utilities'

export function ReplaceStandards({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const treeData = useGetTreeById({ treeId, versionId })
  useSetAtom(workingTreeAtom)(treeData)
  const tree = treeData.tree

  const [tableReplacements, setTableReplacements] = useState<string>('')
  const [standardState, setStandardState] = useState<string>('')

  // Get both the normalized map and original standard names
  const { normalizedMap, originalValues, originalReplacements } =
    getNormalizedReplacementMap(tableReplacements)

  const [treeStandards, setTreeStandards] = useState<TreeStandards>()
  useEffect(() => {
    if (!tree) return
    TreeStandards.create(tree).then((treeStandards) => {
      setTreeStandards(treeStandards)
    })
  }, [tree])
  if (!tree) return <Box>Loading...</Box>

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 2, fontSize: '1.2rem', fontWeight: 'bold' }}>
        Standards to Find/Replace
      </Box>
      <Box sx={{ mb: 2 }}>
        <Box sx={{ fontWeight: 'bold', mb: 0.5 }}>
          Enter standards to replace:
        </Box>
        <Box sx={{ pl: 2, fontSize: '0.9em', color: '#555' }}>
          • Each line: original standard followed by one or more replacements
          <br />
          • Items can be separated by spaces or tabs
          <br />
          • Punctuation like commas and semicolons in replacements will be
          normalized
          <br />
          • Original standards with spaces should be connected (use periods,
          hyphens, etc.)
          <br />
          • Examples:
          <br />
          <Box sx={{ pl: 2, fontFamily: 'monospace', mt: 0.5 }}>
            W.7.2.a 7W2a
            <br />
            W.7.2.c 7W1d 7W2d
            <br />
            W.7.2.d 7W2c 7W1c
            <br />
            W.7.4 7W1f 7W2f
          </Box>
        </Box>
      </Box>
      <TextField
        multiline
        fullWidth
        rows={4}
        placeholder="orig rep1 rep2 ..."
        value={tableReplacements}
        onChange={({ target: { value } }) => {
          setTableReplacements(value)
        }}
        sx={{ mb: 3 }}
      />

      <Box sx={{ mb: 3 }}>
        <StandardStateSelect
          value={standardState}
          onChange={setStandardState}
        />
      </Box>

      {treeStandards && standardState && (
        <ReplaceStandardsTable
          treeStandards={treeStandards}
          standardsReplacementMap={normalizedMap}
          originalStandardsMap={originalValues}
          originalReplacements={originalReplacements}
          standardState={standardState}
        />
      )}
    </Box>
  )
}
